import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/utils/utils"

export interface InputProps
    extends React.InputHTMLAttributes<HTMLInputElement>,
    VariantProps<typeof inputVariants> { }

const inputVariants = cva(
    "flex h-10 w-full rounded-md border px-3 py-2 text-sm transition-all duration-200 file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 md:h-11 md:px-4 md:text-base",
    {
        variants: {
            variant: {
                default:
                    "border-amber-500 bg-amber-300/40 text-blue-950 placeholder:text-blue-900/50 focus-visible:border-blue-900 hover:border-blue-900 hover:bg-amber-400",
                admin:
                    "border-blue-900/35 bg-white text-blue-950 placeholder:text-blue-900/40 shadow-sm focus-visible:border-blue-800 focus-visible:ring-2 focus-visible:ring-blue-900/10 hover:border-blue-900/60 hover:bg-amber-50/50",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
);

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className, type, variant, ...props }, ref) => {
        return (
            <input
                type={type}
                className={cn(
                    inputVariants({ variant }),
                    className
                )}
                ref={ref}
                {...props}
            />
        )
    }
)
Input.displayName = "Input"

export { Input }
